import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDataFlowDeviceDetailsResData } from "./GetDataFlowDeviceDetailsResData";

const ENDPOINT = "/dataflow/devicedetails";

export class GetDataFlowDeviceDetailsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetDataFlowDeviceDetailsReqData = null;

    constructor(installationName: string, converterType: string) {
        super();
        this.params = new GetDataFlowDeviceDetailsReqData(installationName, converterType);
    }

    public async execute(): Promise<GetDataFlowDeviceDetailsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetDataFlowDeviceDetailsResData(res);
    }
}

export class GetDataFlowDeviceDetailsReqData {
    installationName: string;
    converterType: string;

    constructor(installationName: string, converterType: string) {
        this.installationName = installationName;
        this.converterType = converterType;
    }
}
